import { render, staticRenderFns } from "./phoneExtItemForm.vue?vue&type=template&id=0ea67fdc&"
import script from "./phoneExtItemForm.vue?vue&type=script&lang=js&"
export * from "./phoneExtItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports